import { render } from "./index.vue?vue&type=template&id=553a27b8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=553a27b8&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\user\\Desktop\\production\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553a27b8"]])

export default __exports__